<template>
  <div>
    <v-row>
      <v-col xs="12">
        <v-row align="center" justify="end" class="pb-4">
          <v-col v-if="!canWrite || hasMultipleActiveWatchers" class="blue-grey--text text--lighten-1">
            <v-icon color="red">mdi-alert-box-outline</v-icon>
            {{ hasMultipleActiveWatchers ? $t('vmail.notify.hasMultipleWatchers') : $t('perms.nochange') }}
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col sm="12" md="6" lg="6" xl="4">
        <account-settings />
      </v-col>
      <v-col sm="12" md="6" lg="6" xl="4">
        <transcription-settings />
      </v-col>
      <v-col sm="12" md="6" lg="6" xl="4">
        <voicemailbox-settings />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import AccountSettings from '@/components/voicemails/settings/general/account'
import TranscriptionSettings from '@/components/voicemails/settings/general/transcription'
import VoicemailboxSettings from '@/components/voicemails/settings/general/voicemailbox'

export default {
  name: 'vmail-settings',
  components: { AccountSettings, TranscriptionSettings, VoicemailboxSettings },
  computed: {
    ...mapGetters({
      vmbox: 'voicemails/vmboxSettings',
      currentUserID: 'settings/userID',
      vmboxWriteFor: 'permissions/vmboxWriteFor',
      canWriteCurrentUser: 'permissions/vmboxesWrite',
      vmWatcherBoxID: 'voicemails/watcherBoxID',
      vmWatcherSubscriberID: 'voicemails/watcherSubscriberID',
      vmWatcherUserID: 'voicemails/watcherUserID',
      activeWatchers: 'voicemails/activeWatchers'
    }),
    canWrite: function () {
      if (this.activeWatchers.length > 1) {
        return false
      }
      if (this.currentUserID === this.vmWatcherUserID) {
        return this.canWriteCurrentUser
      }
      return this.vmboxWriteFor(this.vmWatcherSubscriberID)
    },
    hasMultipleActiveWatchers: function () {
      return this.activeWatchers.length > 1
    }
  }
}
</script>

<style scoped>
.settings-switch {
  padding-bottom: 0;
  margin-bottom: 0;
}
.vmb-attach,
.vmb-deletevm,
.vmb-playcid,
.vmb-envelope,
.vmb-transcript,
.vmb-translate,
.vmb-skip-instruct {
  margin-top: 0;
}
</style>
